
export const scaledPixel = (px: number) => px  * window.devicePixelRatio

export const mps2miph = (mps: number) => mps / 0.44704